import React, { useEffect } from 'react'
import Button from 'monday-ui-react-core/dist/Button'
import Loader from '../cmps/MondayLoader'
import mondaySdk from 'monday-sdk-js'
import { AttentionBox } from 'monday-ui-react-core'
const monday = mondaySdk()
export default function Login({ onTabBackEvent, loading, domain, userEmail }) {
  useEffect(() => {
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [])

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      console.log('Event visibile fired')
      onTabBackEvent()
    }
  }

  const oAuthLogin = async () => {
    document.addEventListener('visibilitychange', handleVisibilityChange)
    // fetch a fresh session token at click time (they are short-lived) - the backend
    // verifies it to bind the OAuth flow to this user
    const res = await monday.get('sessionToken')
    monday.execute('openLinkInTab', { url: `${domain}/api/auth/authorization?sessionToken=${encodeURIComponent(res.data)}` })
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="login">
          <h1 className="login-header">Welcome to OKR Management</h1>
          <h3 className="login-sec-header">To continue, please click on the "connect to monday" button</h3>
          <Button color={Button.colors.PRIMARY} className="add-button connect-btn" size={Button.sizes.LARGE} onClick={() => oAuthLogin()}>
            Connect to monday.com
          </Button>

          <AttentionBox className="mirror-sync-install-container">
            <p>
              If you would like to use the{' '}
              <a onClick={() => monday.execute('openLinkInTab', { url: 'https://monday.com/marketplace/listing/10000660/mirrorsync' })} style={{ color: 'var(--link-on-secondary-color)' }} href="#">
                MirrorSync
              </a>{' '}
              app but haven’t installed it on your account yet, click below:
            </p>
            <div>
              <a  className='add-to-monday' onClick={ () => monday.execute('openLinkInTab', { url: "https://auth.monday.com/oauth2/authorize?client_id=bd075b073e8f03e51c364ccc8ff1681b&response_type=install"})} aria-label="Install MirrorSync on monday.com">
                <img alt="Add to monday.com" height="32" src="https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/uploads/Tal/4b5d9548-0598-436e-a5b6-9bc5f29ee1d9_Group12441.png" />
              </a>
            </div>
          </AttentionBox>
        </div>
      )}
    </>
  )
}
